import React from 'react';
import { PieChart, TrendingUp, TrendingDown, Briefcase } from 'lucide-react';

const Portfolio = ({ userData }: { userData?: any }) => {
  // Dummy holdings data for UI
  const holdings = [
    { symbol: 'RELIANCE', name: 'Reliance Industries', qty: 15, avgPrice: 2850.50, ltp: 2910.20, change: '+2.1%' },
    { symbol: 'TCS', name: 'Tata Consultancy', qty: 10, avgPrice: 3950.00, ltp: 3890.10, change: '-1.5%' },
    { symbol: 'HDFCBANK', name: 'HDFC Bank', qty: 25, avgPrice: 1420.00, ltp: 1455.75, change: '+2.5%' },
  ];

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <div>
        <h1 className="text-3xl font-bold text-white">Your Portfolio</h1>
        <p className="text-gray-400 mt-1">Track your investments and asset allocation.</p>
      </div>

      {/* Portfolio Metrics */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl">
          <div className="flex items-center gap-3 mb-4"><Briefcase className="text-blue-500" size={20} /><h3 className="text-gray-400 font-medium">Invested Value</h3></div>
          <h2 className="text-3xl font-bold text-white">₹1,17,757.50</h2>
        </div>
        <div className="bg-[#131b2c] border border-gray-800 rounded-2xl p-6 shadow-xl">
          <div className="flex items-center gap-3 mb-4"><PieChart className="text-purple-500" size={20} /><h3 className="text-gray-400 font-medium">Current Value</h3></div>
          <h2 className="text-3xl font-bold text-white">₹1,18,944.25</h2>
        </div>
        <div className="bg-gradient-to-br from-green-500/10 to-transparent border border-green-500/20 rounded-2xl p-6 shadow-xl">
          <div className="flex items-center gap-3 mb-4"><TrendingUp className="text-green-500" size={20} /><h3 className="text-gray-400 font-medium">Total Returns</h3></div>
          <h2 className="text-3xl font-bold text-green-400">+₹1,186.75 (1.01%)</h2>
        </div>
      </div>

      {/* Holdings Table */}
      <div className="bg-[#131b2c] border border-gray-800 rounded-2xl overflow-hidden shadow-xl">
        <div className="p-6 border-b border-gray-800 flex justify-between items-center">
          <h3 className="text-xl font-bold text-white">Your Holdings</h3>
          <button className="text-sm font-bold text-blue-500 hover:text-blue-400 transition-colors">View Analytics</button>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-[#0b1221] text-gray-500 text-xs uppercase tracking-wider">
                <th className="p-4 font-medium">Asset</th>
                <th className="p-4 font-medium">Qty</th>
                <th className="p-4 font-medium">Avg Price</th>
                <th className="p-4 font-medium">LTP</th>
                <th className="p-4 font-medium text-right">P&L</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-800">
              {holdings.map((stock, idx) => (
                <tr key={idx} className="hover:bg-[#1e222d]/50 transition-colors">
                  <td className="p-4">
                    <p className="font-bold text-white">{stock.symbol}</p>
                    <p className="text-xs text-gray-500">{stock.name}</p>
                  </td>
                  <td className="p-4 text-white">{stock.qty}</td>
                  <td className="p-4 text-white">₹{stock.avgPrice.toFixed(2)}</td>
                  <td className="p-4 text-white">₹{stock.ltp.toFixed(2)}</td>
                  <td className={`p-4 text-right font-bold ${stock.change.startsWith('+') ? 'text-green-500' : 'text-red-500'}`}>
                    {stock.change}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;